interface MarkProps {
  className?: string;
}

export function ArchMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none">
      <path d="M 15 95 L 15 50 A 35 35 0 0 1 85 50 L 85 95" stroke="currentColor" strokeWidth="4" strokeLinecap="square" />
      <path d="M 25 95 L 25 50 A 25 25 0 0 1 75 50 L 75 95" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" opacity="0.5" />
      <circle cx="50" cy="35" r="8" fill="currentColor" />
      <line x1="5" y1="95" x2="95" y2="95" stroke="currentColor" strokeWidth="4" />
    </svg>
  );
}
